import React, { useState } from "react";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";

// Creative Tim Cards
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";

// Material UI
import { Typography, Button } from "@material-ui/core";
import { authApi } from "../auth/authApi";

export default function TradingViewDashboard() {
    const roles = JSON.parse(localStorage.getItem("roles") || "[]");
    const hasTradingRole = roles.includes("Trading.View");

    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const requestTradingAccess = async () => {
        try {
            setLoading(true);
            setMessage("");
            setError("");

            const result = await authApi.requestRole("Trading.View");
            setMessage(result || "Antrag wurde gestellt.");
        } catch (err) {
            setError(err?.message || "Antrag konnte nicht gestellt werden.");
        } finally {
            setLoading(false);
        }
    };

    if (!hasTradingRole) {
        return (
            <GridContainer>
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="info">
                            <h4 style={{ color: "#fff", margin: 0 }}>TradingView</h4>
                        </CardHeader>
                        <CardBody style={{ padding: 24 }}>
                            <Typography variant="h6" gutterBottom>
                                Kein Zugriff auf Trading View
                            </Typography>

                            <Typography variant="body1" style={{ marginBottom: 16 }}>
                                Du hast aktuell keine Berechtigung für Trading View.
                                Du kannst die Rolle <strong>Trading.View</strong> beantragen.
                            </Typography>

                            <Button
                                variant="contained"
                                color="primary"
                                onClick={requestTradingAccess}
                                disabled={loading}
                            >
                                {loading ? "Wird beantragt..." : "Trading.View beantragen"}
                            </Button>

                            {message && (
                                <Typography
                                    variant="body2"
                                    style={{ marginTop: 16, color: "#0f766e" }}
                                >
                                    {message}
                                </Typography>
                            )}

                            {error && (
                                <Typography
                                    variant="body2"
                                    style={{ marginTop: 16, color: "#b91c1c" }}
                                >
                                    {error}
                                </Typography>
                            )}
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        );
    }

    return (
        <GridContainer>
            <GridItem xs={12}>
                <Card>
                    <CardHeader color="info">
                        <h4 style={{ color: "#fff", margin: 0 }}>TradingView</h4>
                    </CardHeader>
                    <CardBody style={{ height: "90vh", padding: 0 }}>
                        <iframe
                            src="https://tradingviewapi1966.azurewebsites.net/app?x-api-key=bf7cc9fa400d4b90ad76283217397c42"
                            title="TradingViewApp"
                            style={{
                                width: "100%",
                                height: "100%",
                                border: "none"
                            }}
                        />
                    </CardBody>
                </Card>
            </GridItem>
        </GridContainer>
    );
}